import axios from 'axios'

export default {
    getClass(){
        return axios.get('/class')
            .then(response => {
                return response.data
            })
    },
    getClassDataSource(params){
        return axios.get('/class/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getClassbyID(id){
        return axios.get('/class/' + id)
            .then(response => {
                return response.data
            })
    },    
    createClass(formdata){
        return axios.post('/class', formdata)
            .then(response => {
                return response.data
            })
    },
    updateClass(id,formdata){
        return axios.put('/class/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateClass(id){
        return axios.put('/class/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateClass(id){
        return axios.put('/class/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    
}